<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">{{
            $t("notFound.home")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            $t("orderList.orderList1")
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("orderList.orderList2") }}:</div>
              <div class="flex1">
                <el-input
                  :placeholder="$t('orderList.orderList3')"
                  clearable
                  v-model="queryInfo.id"
                  size="small"
                  @keyup.enter.native="searchList"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("mail.mailTo") }}:</div>
              <div class="flex1">
                <el-input
                  :placeholder="$t('orderList.orderList3')"
                  clearable
                  v-model="queryInfo.receiver"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title1">{{$t('orderList.orderList4')}}:</div>
              <div class="flex1">
                <el-input
                        :placeholder="$t('orderList.orderList3')"
                        clearable
                        v-model="queryInfo.trackingNumberJpn"
                        size="small"
                        @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title1">
                {{ $t("common.createStartDate") }}:
              </div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('common.selectDate')"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("common.createEndDate") }}:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('common.selectDate')"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">{{ $t("orderList.orderList5") }}:</div>
              <div class="flex1">
                <el-input
                  :placeholder="$t('orderList.orderList3')"
                  clearable
                  v-model="queryInfo.trackingNumberCn"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">商品SKU:</div>
              <div class="flex1">
                <el-input
                  placeholder="商品SKU"
                  clearable
                  v-model="queryInfo.goodsNumber"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">品名:</div>
              <div class="flex1">
                <el-input
                  placeholder="品名"
                  clearable
                  v-model="queryInfo.goodsNameCus"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title1">バーコード:</div>
              <div class="flex1">
                <el-input
                  placeholder="バーコード"
                  clearable
                  v-model="queryInfo.fnsku"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title1">FBA/YFF/ZOZO/RSL/ストッククルー:</div>
              <div class="flex1" style="margin-left: 25px">
                <el-select
                  v-model="queryInfo.orderType"
                  placeholder="FBA/YFF/ZOZO/RSL/ストッククルー"
                  size="small"
                >
                  <el-option
                    v-for="item in fbaOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row" v-if="isClientManage === '1'">
              <div class="query-title">{{ $t("cnumber.cnumber20") }}:</div>
              <div class="flex1">
                <ChildCode v-model="queryInfo.customerUserId"></ChildCode>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="18" class="display-row">
            <el-button
              class="search-btn btn-white"
              :class="{ lxBtnGreenDeep: curIndex === 0 }"
              @click="quickSearchList('', (index = 0))"
              >{{ $t("wzbg.wz19") }}</el-button
            >
            <el-button
              class="search-btn btn-white"
              :class="{ lxBtnGreenDeep: curIndex === 1 }"
              @click="quickSearchList('24', (index = 1))"
              >{{ $t("orderList.orderList34")
              }}<span class="lx-red"
                >({{ orderData.badPendingCount }})</span
              ></el-button
            >
            <el-button
              class="search-btn btn-white"
              :class="{ lxBtnGreenDeep: curIndex === 2 }"
              @click="quickSearchList('28,32', (index = 2))"
              >{{ $t("orderList.orderList36")
              }}<span class="lx-red"
                >({{ orderData.inExChangeCount }})</span
              ></el-button
            >
            <el-button
              class="search-btn btn-white"
              :class="{ lxBtnGreenDeep: curIndex === 3 }"
              @click="quickSearchList('36,68', (index = 3))"
              >{{ $t("badOrder.badOrder1")
              }}<span class="lx-red"
                >({{ orderData.returningCount }})</span
              ></el-button
            >
            <el-button
              class="search-btn btn-white"
              :class="{ lxBtnGreenDeep: curIndex === 4 }"
              @click="quickSearchList('40', (index = 4))"
              >{{ $t("orderList.orderList136")
              }}<span class="lx-red"
                >({{ orderData.reissueCount }})</span
              ></el-button
            >
            <el-button
              class="search-btn btn-white"
              :class="{ lxBtnGreenDeep: curIndex === 5 }"
              @click="quickSearchList('82,83', (index = 5))"
              >{{ $t("badOrder.badOrder2")
              }}<span class="lx-red"
                >({{ orderData.destroyCount }})</span
              ></el-button
            >
            <!-- <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 6}" @click="quickSearchList('26,56,84,72',index = 6)">{{$t('status.status3')}}</el-button> -->
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{
                $t("reset")
              }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{
                $t("query")
              }}</el-button>
              <el-button class="search-btn btn-green" @click="doAddCart">{{
                $t("orderList.addCart")
              }}</el-button>
              <el-button class="search-btn btn-green" @click="toSort">{{
                $t("orderList.orderList156")
              }}</el-button>
              <el-button
                class="search-btn btn-blue"
                v-if="!isActive"
                type="primary"
                icon="el-icon-arrow-down"
                style="margin-top: 5px;"
                alt=""
                @click="isActive = !isActive"
                >{{ $t("search.expandPanel") }}</el-button
              >
              <el-button
                class="search-btn btn-green"
                v-if="isActive"
                icon="el-icon-arrow-up"
                style="margin-top: 5px;"
                alt=""
                @click="isActive = !isActive"
                >{{ $t("search.retractPanel") }}</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div
        slot="table"
        class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative"
      >
        <lx-table
          :list="orderList"
          isSelectTable
          border
          stripe
          :rowKey="'id'"
          :emptyText="$t('select.select24')"
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          @selectionChange="orderSelectedChanged"
        >
          <el-table-column
            v-for="(item, index) in asyncColumns"
            :key="index"
            align="center"
            :label="item.name"
            :prop="item.key"
            :width="item.width ? item.width : 'auto'"
            :min-width="item.minWidth ? item.minWidth : 'auto'"
          >
            <template v-slot="scope">
              <!-- 操作 -->
              <div v-if="item.key === 'handle'">
                <el-button
                  class="list-btn btn-blue"
                  @click="toOrderDetail(scope.row)"
                >
                  {{ $t("detail") }}</el-button
                >
                <!-- <el-button
                  class="list-btn btn-green"
                  v-if="editOrderStatus.indexOf(scope.row.orderStatus) > -1"
                  @click="toEditOrder(scope.row)"
                >
                  {{$t('editor')}}</el-button> -->
                <el-button
                  class="list-btn btn-deepblue"
                  v-if="['1'].indexOf(scope.row.orderStatus) > -1"
                  @click="toRefundOrder(scope.row)"
                >
                  {{ $t("orderList.orderList16") }}</el-button
                >
                <el-button
                  class="list-btn btn-deepblue"
                  v-if="['60'].indexOf(scope.row.orderStatus) > -1"
                  @click="toRefundOrderCannel(scope.row)"
                >
                  {{ $t("orderList.orderList17") }}</el-button
                >
                <el-button
                  class="list-btn btn-deepblue"
                  v-if="
                    ['0', '2', '4', '8', '12', '16'].indexOf(
                      scope.row.orderStatus
                    ) > -1
                  "
                  @click="toDestroyOrder(scope.row)"
                >
                  {{ $t("orderList.orderList18") }}</el-button
                >
                <el-button
                  class="list-btn btn-deepblue"
                  v-if="['76'].indexOf(scope.row.orderStatus) > -1"
                  @click="toDestroyOrderCannel(scope.row)"
                >
                  {{ $t("orderList.orderList19") }}</el-button
                >
                <el-button
                  class="list-btn btn-green"
                  v-if="
                    ['0', '1', '2', '4', '8', '16'].indexOf(
                      scope.row.orderStatus
                    ) > -1 && scope.row.goodsCount > 1
                  "
                  @click="toSpiltOrder(scope.row)"
                >
                  {{ $t("orderList.orderList20") }}</el-button
                >
                <el-button
                  class="list-btn btn-deepblue"
                  v-if="
                    ['0', '1', '2', '16'].indexOf(scope.row.orderStatus) > -1
                  "
                  @click="toCancelOrder(scope.row)"
                >
                  {{ $t("cancel") }}</el-button
                >
                <!-- <el-button class="list-btn btn-blue" v-if="billOrderStatus.indexOf(scope.row.orderStatus) > -1 " @click="toOrderBill(scope.row)">
                  {{$t('orderList.orderList21')}}</el-button>
                <el-button class="list-btn btn-red" v-if="billOrderPayStatus.indexOf(scope.row.orderStatus) > -1" @click="toOrderBillPay(scope.row)">
                  {{$t('orderList.orderList22')}}</el-button> -->
                <el-button
                  class="list-btn btn-blue"
                  @click="messageAdd(scope.row)"
                  >{{ $t("orderList.orderList23") }}</el-button
                >

                <el-button
                  v-show="scope.row.orderStatus == 24"
                  class="list-btn-four btn-blue"
                  @click="
                    $router.push({
                      path: '/defective',
                      query: { orderid: scope.row.id },
                    })
                  "
                >
                  {{ $t("badOrder.badOrder3") }}
                </el-button>
              </div>
              <!-- 订单编号 -->
              <div v-else-if="item.key === 'splitOrderId'">
                <div>
                  <span>{{ scope.row.id }}</span>
                </div>
                <div v-if="scope.row.splitOrderId">
                  <font
                    color="#0082FF"
                    @click="
                      $router.push({
                        name: 'orderDetail',
                        query: { id: scope.row.splitOrderId, isEdit: '0' },
                      })
                    "
                    style="cursor: pointer"
                    >{{ scope.row.splitOrderId }}-{{ scope.row.splitSeq }}</font
                  >
                </div>
              </div>
              <!-- 创建时间 -->
              <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | dateFormatToSecond }}
              </div>
              <!-- 同捆 -->
              <!-- <el-link v-else-if="item.key === 'tongkunNo'" :underline="true" @click="toTongkunDetail(scope.row)">
                {{scope.row.tongkunNo==null?'':scope.row.tongkunNo+(scope.row.orderCount==null?'':'('+scope.row.orderCount+')')}}
              </el-link> -->
              <!-- 国内物流 -->
              <div v-else-if="item.key === 'trackingNumberCn'">
                <div
                  class="btn-row"
                  v-if="
                    scope.row.orderStatus !== '0' &&
                    scope.row.orderStatus !== '1' &&
                    scope.row.orderStatus !== '2'
                  "
                >
                  {{ scope.row.trackingNumberCn }}
                </div>
                <div
                  class="btn-row"
                  v-if="
                    scope.row.orderStatus === '0' ||
                    scope.row.orderStatus === '1' ||
                    scope.row.orderStatus === '2'
                  "
                >
                  <el-input
                    @blur="saveTrackingNumberCn(scope.row)"
                    :placeholder="$t('orderList.orderList25')"
                    v-model="scope.row.trackingNumberCn"
                    size="small"
                  >
                  </el-input>
                </div>
                <div
                  class="btn-row overflowDot"
                  :title="scope.row.cnLogisticsStatus"
                >
                  {{ scope.row.cnLogisticsStatus }}
                </div>
              </div>
              <!-- 国际物流 -->
              <!-- <div v-else-if="item.key === 'trackingNumberJpn'">
                <div class="btn-row">
                  {{scope.row.trackingNumberJpn}}
                </div>
                <div class="btn-row overflowDot" :title="scope.row.sagawaState">
                  {{scope.row.sagawaState}}
                </div>
              </div> -->
              <!-- 订单状态 -->
              <div class="btn-row" v-else-if="item.key === 'orderStatus'">
                {{ scope.row.orderStatus | orderStatusFilter }}
              </div>
              <!-- 商品信息 -->
              <div v-else-if="item.key === 'shopInfo'">
                <div class="lx-text-left-row">
                  <div
                    style="width: 80px; text-align: right"
                    class="table-cell-title-min"
                  >
                    {{ $t("orderList.orderList26") }}：
                  </div>
                  <div style="width: 100px">{{ scope.row.colour }}</div>
                </div>
                <div class="lx-text-left-row">
                  <div
                    style="width: 80px; text-align: right"
                    class="table-cell-title-min"
                  >
                    {{ $t("orderList.orderList27") }}：
                  </div>
                  <div style="width: 100px">{{ scope.row.goodsSize }}</div>
                </div>
                <div class="lx-text-left-row" style="display: flex">
                  <div
                    style="width: 80px; text-align: right"
                    class="table-cell-title-min"
                  >
                    {{ $t("orderList.orderList28") }}：
                  </div>
                  <el-input
                    type="textarea"
                    style="width: 100px"
                    @change="quickSave($event, scope.row)"
                    v-model="scope.row.goodsNumber"
                    size="mini"
                  >
                  </el-input>
                </div>
              </div>
              <!-- 商品数量 -->
              <div v-else-if="item.key === 'shopNum'">
                <div class="lx-text-left">
                  <span class="table-cell-title-mid"
                    >{{ $t("orderList.orderList29") }}：</span
                  >
                  <span>{{ scope.row.goodsCount }}</span>
                </div>
                <div class="lx-text-left">
                  <span class="table-cell-title-mid"
                    >{{ $t("orderList.orderList30") }}：</span
                  >
                  <span>{{ scope.row.waitBoxCount }}</span>
                </div>
                <div class="lx-text-left">
                  <span class="table-cell-title-mid"
                    >{{ $t("orderList.orderList31") }}：</span
                  >
                  <span>{{ scope.row.refundCount }}</span>
                </div>
                <div class="lx-text-left">
                  <span class="table-cell-title-mid"
                    >{{ $t("orderList.orderList32") }}：</span
                  >
                  <span>{{ scope.row.destroyCount }}</span>
                </div>
              </div>
              <!-- 检品 -->
              <div v-else-if="item.key === 'inspection'" class="lx-text-left">
                <span
                  v-if="scope.row.inspection && scope.row.inspection.length > 0"
                >
                  <div
                    v-for="item in scope.row.inspection.split(',')"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                </span>
              </div>
              <!-- 仓库保管 -->
              <div v-else-if="item.key === 'categoryFlag'">
                {{
                  scope.row.categoryFlag == 0
                    ? $t("running.suspended0")
                    : $t("running.suspended1")
                }}
                <div
                  class="btn-row"
                  v-if="
                    scope.row.categoryFlag == '0' &&
                    storeKeepingStatus.indexOf(scope.row.orderStatus) > -1
                  "
                >
                  <el-button
                    class="list-btn btn-blue"
                    @click="toStoreKeeping(scope.row)"
                  >
                    {{ $t("update") }}</el-button
                  >
                </div>
                <div
                  class="btn-row"
                  v-if="
                    scope.row.categoryFlag == '1' &&
                    scope.row.orderStatus == '16' &&
                    scope.row.applicationSend != '1'
                  "
                >
                  <el-button
                    class="list-btn btn-green"
                    @click="toSendOrder(scope.row)"
                  >
                    {{ $t("orderList.orderList33") }}</el-button
                  >
                </div>
              </div>
              <!-- 包装意向 -->
              <div v-else-if="item.key === 'putIntent'">
                {{ scope.row.putIntent | putIntentFilter }}
              </div>
              <!-- 图片 -->
              <div v-else-if="item.key === 'pictureUrl'">
                <img
                  @click="imgclick(scope.row.pictureUrl, true)"
                  v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0"
                  :src="scope.row.pictureUrl + commonData.smallimg"
                  alt=""
                  class="list-image"
                />
                <img
                  v-else
                  src="../../../assets/images/default.png"
                  alt=""
                  class="list-image"
                />
                <div class="btn-row">
                  <el-button
                    class="list-btn-four btn-blue"
                    @click="toGoodsDetail(scope.row)"
                  >
                    {{ $t("menu.menu5") }}
                  </el-button>
                </div>
              </div>
              <!-- 是否fba -->
              <div v-else-if="item.key === 'orderType'">
                {{ scope.row.orderType | ordertypeFilter }}
                <div v-if="scope.row.orderType == 1">
                  <span style="margin-right: 10px">バーコード:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 0">
                  <span style="margin-right: 10px">FNSKU:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 2 || scope.row.orderType == 5">
                  <span style="margin-right: 10px">検品コード※商品バーコード情報:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 3">
                  <span style="margin-right: 10px">ZOZOバーコード:</span>{{ scope.row.fnsku }}
                </div>
                <div v-if="scope.row.orderType == 4">
                  <span style="margin-right: 10px">RSLバーコード:</span>{{ scope.row.fnsku }}
                </div>
                <div>
                  <span style="margin-right: 10px">品名:</span>{{ scope.row.goodsNameCus }}
                </div>
                <div v-if="scope.row.orderType == 0">
                  <span style="margin-right: 10px">ASIN:</span>{{ scope.row.asin }}
                </div>
              </div>
              <!-- 不良数量 -->
              <div v-else-if="item.key === 'badInfo'">
                <div>
                  <span class="table-cell-title"
                    >{{ $t("orderList.orderList34") }}：</span
                  >
                  <span>{{ scope.row.badCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title"
                    >{{ $t("orderList.orderList35") }}：</span
                  >
                  <span>{{ scope.row.reissueCount }}</span>
                </div>
                <div>
                  <span class="table-cell-title"
                    >{{ $t("orderList.orderList36") }}：</span
                  >
                  <span>{{ scope.row.exchangCount }}</span>
                </div>
              </div>
              <div v-else-if="item.key === 'userCode'">
                {{ scope.row.userName }}
              </div>
              <!-- 其他不需要处理的 -->
              <span v-else>
                {{ scope.row[item.key] }}
              </span>
            </template>
          </el-table-column>
        </lx-table>
        <el-pagination
          class="lx-page-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 拆单 -->
    <el-dialog
      width="80%"
      :title="$t('orderList.orderList20')"
      :visible.sync="splitDialogVisible"
      @close="splitDialogClosed"
    >
      <el-row>
        <el-col :span="12" class="split-col">
          <el-form label-width="125px" class="demo-ruleForm">
            <div class="split-title">{{ $t("orderList.orderList37") }}：</div>
            <div>
              <el-form-item :label="$t('orderList.orderList38')">
                <el-input v-model="originSpiltOrderInfo.id" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList39')">
                <el-select
                  v-model="originSpiltOrderInfo.orderStatus"
                  :placeholder="$t('goods.goods21')"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in orderStatusOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList40')">
                <el-input
                  v-model="originSpiltOrderInfo.goodsCount"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList41')">
                <el-input
                  v-model="originSpiltOrderInfo.refundCount"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList42')">
                <el-input
                  v-model="originSpiltOrderInfo.destroyCount"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList43')">
                <el-select
                  v-model="originSpiltOrderInfo.orderType"
                  :placeholder="$t('goods.goods21')"
                  size="small"
                  disabled
                >
                  <el-option
                    key="0"
                    value="0"
                    :label="$t('running.suspended1')"
                  ></el-option>
                  <el-option
                    key="1"
                    value="1"
                    :label="$t('running.suspended0')"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList44')">
                <el-select
                  v-model="originSpiltOrderInfo.categoryFlag"
                  :placeholder="$t('goods.goods21')"
                  size="small"
                  disabled
                >
                  <el-option
                    key="1"
                    value="1"
                    :label="$t('running.suspended1')"
                  ></el-option>
                  <el-option
                    key="0"
                    value="0"
                    :label="$t('running.suspended0')"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col :span="12" class="split-col">
          <el-form
            :model="spiltOrderInfo"
            :rules="spiltOrderRules"
            ref="spiltInfoForm"
            label-width="120px"
            class="split-form"
          >
            <div class="split-title">{{ $t("orderList.orderList45") }}：</div>
            <div>
              <el-form-item :label="$t('orderList.orderList46')">
                <el-select
                  v-model="spiltOrderInfo.orderStatus"
                  :placeholder="$t('goods.goods21')"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in orderStatusOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('createOrder.createOrder23')">
                <el-select
                  v-model="spiltOrderInfo.orderType"
                  :placeholder="$t('goods.goods21')"
                  size="small"
                  disabled
                >
                  <el-option
                    key="0"
                    value="0"
                    :label="$t('running.suspended1')"
                  ></el-option>
                  <el-option
                    key="1"
                    value="1"
                    :label="$t('running.suspended0')"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('orderList.orderList47')">
                <el-select
                  v-model="spiltOrderInfo.categoryFlag"
                  :placeholder="$t('goods.goods21')"
                  size="small"
                  disabled
                >
                  <el-option
                    key="1"
                    value="1"
                    :label="$t('running.suspended1')"
                  ></el-option>
                  <el-option
                    key="0"
                    value="0"
                    :label="$t('running.suspended0')"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('excel.excel7')" prop="goodsCount">
                <el-input v-model="spiltOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('orderList.orderList48')"
                prop="refundCount"
              >
                <el-input v-model="spiltOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('orderList.orderList49')"
                prop="destroyCount"
              >
                <el-input v-model="spiltOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="form-btn btn-gray"
          @click="splitDialogVisible = false"
          >{{ $t("cancel") }}</el-button
        >
        <el-button
          class="form-btn btn-blue"
          @click="splitSave('spiltInfoForm')"
          >{{ $t("submit") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 提醒 -->
    <el-dialog
      :title="$t('orderList.orderList23')"
      :visible.sync="replyDialogVisible"
      width="50%"
      @close="replyDialogClose"
    >
      <el-form
        :model="replyInfo"
        :rules="rules"
        ref="replyInfo"
        label-width="140px"
        class="demo-replyInfo"
      >
        <!-- 只读 -->
        <el-form-item :label="$t('orderList.orderList50')">
          <span>{{ $t("orderList.orderList51") }}</span>
        </el-form-item>
        <el-form-item :label="$t('orderList.orderList52')">
          <span>{{ replyMessageInfo.id }}</span>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item
          :label="$t('orderList.orderList53')"
          prop="remindingTitle"
        >
          <el-input
            maxlength="100"
            v-model="replyInfo.remindingTitle"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('orderList.orderList54')"
          prop="remindingContent"
        >
          <!-- <el-input v-model="replyInfo.remindingContent"></el-input> -->
          <quill-editor
            ref="text"
            v-model="replyInfo.remindingContent"
            :options="editorOption"
          />
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('orderList.orderList55')">
          <el-upload
            class="editor-slide-upload"
            action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
            :data="imgDataObj"
            accept="image/png,image/jpeg"
            :multiple="true"
            :file-list="listObj"
            :show-file-list="true"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleImgRemove"
            :on-success="handleImgSuccess"
            :before-upload="beforeImgUpload"
            :on-exceed="handleExceed"
            :limit="9"
          >
            <el-button size="small" type="primary" class="btn">{{
              $t("upload.button")
            }}</el-button>
          </el-upload>
          <el-dialog :append-to-body="true" :visible.sync="viewVisible">
            <img width="100%" :src="viewImageUrl" alt="" />
          </el-dialog>
          <div ref="preview" @paste="handlePaste" class="paste-img"></div>
        </el-form-item>
        <!--上传附件-->
        <el-form-item :label="$t('createOrder.createOrder117')">
          <el-upload
            class="editor-slide-upload"
            action=""
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUploadFile"
            :before-remove="beforeRemove"
            :on-success="handleOrderInfo"
            multiple
            :show-file-list="true"
            :limit="3"
            :on-exceed="handleExceed"
            :file-list="attachmentList"
            :http-request="excelUploadRequest"
          >
            <el-button class="search-btn btn-blue">{{
              $t("createOrder.createOrder117")
            }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="replyDialogClose">{{
          $t("cancel")
        }}</el-button>
        <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">{{
          $t("submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <lx-sort
      :visible.sync="isVisibleSort"
      :list="columns"
      @confirm="doSaveColumns"
    ></lx-sort>
  </div>
</template>

<script>
import ChildCode from "@/components/ChildCode/index.vue";

const toolbarOptions = [
  ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
];
import { columns as originColumns } from "./columns";
import LxTable from "@/components/LxTable";
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import Oss from "../../../assets/js/oss.js";
import tableCon from "../../../views/tableContainer";
export default {
  components: {
    ChildCode,
    LxTable,
    LxSort,
    tableCon,
  },
  data() {
    // 自定义邮箱校验规则
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) <= 0 ||
          parseInt(value) >= parseInt(this.originSpiltOrderInfo.goodsCount)
        ) {
          callback(new Error(this.$t("orderList.orderList56")));
        }
        callback();
      } else {
        callback(new Error(this.$t("orderList.orderList57")));
      }
    };
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(this.originSpiltOrderInfo.refundCount)
        ) {
          callback(new Error(this.$t("orderList.orderList58")));
        }
        callback();
      } else {
        callback(new Error(this.$t("orderList.orderList59")));
      }
    };
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(this.originSpiltOrderInfo.destroyCount)
        ) {
          callback(new Error(this.$t("orderList.orderList60")));
        }
        callback();
      } else {
        callback(new Error(this.$t("orderList.orderList61")));
      }
    };
    return {
      isClientManage: this.$store.state.isClientManage,
      viewImageUrl: "",
      viewVisible: false,
      isActive: false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: "badOrder",
      },
      queryInfo: {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        orderStatus: "",
        receiver: "",
        customerUserId: "",
        pageSize: 10,
        pageNum: 1,
      },
      fbaOption: [
        {
          label: this.$t("running.suspended0"),
          value: "1",
        },
        {
          label: "FBA",
          value: "0",
        },
        {
          label: "YFF",
          value: "2",
        },
        {
          label: "ZOZO",
          value: "3",
        },
        {
          label: "RSL",
          value: "4",
        },
        {
          label: "ストッククルー",
          value: "5",
        },
      ],
      orderData: {
        badPendingCount: 0,
        inExChangeCount: 0,
        returningCount: 0,
        reissueCount: 0,
        destroyCount: 0,
        finishedCount: 0,
      },
      visible: false,
      imgurl: "",
      orderStatusQuery: [],
      orderStatusOptions: [],
      orderList: [],
      splitDialogVisible: false,
      originSpiltOrderInfo: {},
      spiltOrderInfo: {},
      total: 0,
      editOrderStatus: [
        "0",
        "1",
        "2",
        "4",
        "8",
        "24",
        "26",
        "40",
        "28",
        "32",
        "36",
        "82",
        "12",
        "16",
      ],
      storeKeepingStatus: [
        "0",
        "4",
        "8",
        "24",
        "26",
        "40",
        "28",
        "32",
        "36",
        "82",
      ],
      billOrderStatus: ["48", "88", "68", "52", "72", "84"],
      billOrderPayStatus: ["44", "64", "80"],
      spiltOrderRules: {
        goodsCount: [
          {
            required: true,
            message: this.$t("orderList.orderList57"),
            trigger: "change",
          },
          { validator: checkGoodsCount },
        ],
        refundCount: [
          {
            required: true,
            message: this.$t("orderList.orderList59"),
            trigger: "change",
          },
          { validator: checkRefundCount },
        ],
        destroyCount: [
          {
            required: true,
            message: this.$t("orderList.orderList61"),
            trigger: "change",
          },
          { validator: checkDestroyCount },
        ],
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
        },
      },
      attachmentList: [],
      listObj: [],
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      replyInfo: {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
        attachment: "",
      },
      rules: {
        remindingTitle: [
          {
            required: true,
            message: this.$t("orderList.orderList62"),
            trigger: "blur",
          },
        ],
        remindingContent: [
          {
            required: true,
            message: this.$t("orderList.orderList63"),
            trigger: "blur",
          },
        ],
      },
      replyMessageInfo: {},
      replyDialogVisible: false,
      selectedOrders: [],
      configLists: {
        // logisticsCompanyConfigList:[], //快递
        inspectionConfigList: [], //标签
        // boxConfigList:[],//装箱
        // oppConfigList:[] //opp袋
      },
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      this.viewImageUrl = file.url;
      this.viewVisible = true;
    },
    async handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      let formdata = new FormData();
      formdata.append("file", file);
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      );
      if (res.code === 200) {
        this.listObj.push({
          name: res.data.fileName,
          url: res.data.filePath,
          hasSuccess: true,
          uid: Date.now(),
        });
      }
    },
    // 获取已选择列
    getAsyncColumns() {
      return new Promise((resolve) => {
        this.$http
          .get("menu/menuSetting", {
            params: {
              menuId: "badOrder",
            },
          })
          .then((res) => {
            var result = [];
            if (res.data.code === 200) {
              var record = res.data.data;
              this.menuSettingData = record;
              result = JSON.parse(record.menuSetting);
            }
            if (result && result.length > 0) {
              result.forEach((item) => {
                this.originColumns.forEach((originItem) => {
                  if (originItem.columnId == item.columnId) {
                    item.name = originItem.name;
                    item.width = originItem.minWidth;
                  }
                });
                this.$set(item, "isShow", true);
              });
              let noSelectList = filterList(
                this.originColumns,
                result,
                "columnId"
              );
              this.columns = result.concat(noSelectList);
              this.asyncColumns = result;
              resolve();
            } else {
              this.columns = this.originColumns;
              this.columns.forEach((item) => {
                this.$set(item, "isShow", true);
              });
              this.asyncColumns = this.columns;
              resolve();
            }
          });
      });
    },
    // 保存选择的列
    doSaveColumns(list) {
      var my = this;
      var url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: this.$t("orderList.orderList83"),
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getOrderList();
          });
        } else {
          my.$message({
            type: "warning",
            message: this.$t("orderList.orderList84"),
          });
        }
      });
    },
    imgclick(url, visible) {
      this.visible = true;
      this.imgurl = url;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    // 加入购物车
    doAddCart() {
      if (this.selectedOrders.length > 0) {
        const idList = this.selectedOrders.map((item) => item.id);
        const url = "shopping/vehicle/copy/add";
        const params = {
          idList,
        };
        this.$http.post(url, params).then(() => {
          this.$message.success(this.$t("success"));
        });
      } else {
        this.$message.error(this.$t("orderList.orderList125"));
      }
    },
    orderSelectedChanged(val) {
      this.selectedOrders = val;
    },
    queryInfoClear() {
      this.queryInfo = {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        orderStatus: "",
        receiver: "",
        pageSize: 10,
        pageNum: 1,
      };
      this.orderDateRangeValue = [];
      this.shipDateRangeValue = [];
    },
    searchList() {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
      this.getStatisticalNum();
    },
    quickSearchList(val, index) {
      this.curIndex = index;
      this.queryInfo.pageNum = 1;
      this.queryInfo.orderStatus = val;
      this.getOrderList();
      this.getStatisticalNum();
    },
    async getOrderList() {
      this.$store.dispatch("setOrderCount");
      const { data: res } = await this.$http.get("badnessOrder/list", {
        params: this.queryInfo,
      });
      console.log(res.data);
      this.orderList = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum() {
      //获取
      const { data: res } = await this.$http.get(
        "/badnessOrder/badnessOrderCount",
        { params: this.queryInfo }
      );
      this.orderData = res.data;
    },
    toTongkunDetail(row) {
      this.$router.push({
        name: "buddleOrderDetail",
        query: {
          id: row.tongkunId,
        },
      });
    },
    toOrderDetail(row) {
      // console.log(row);
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          isEdit: "0",
        },
      });
      // paramsChanged
    },
    toGoodsDetail(row) {
      window.open(row.taobaoUrl, "_blank");
    },
    //支付
    toOrderBillPay(row) {
      this.$router.push({
        name: "orderBill",
        query: {
          id: row.id,
          isEdit: "1",
        },
      });
    }, //账单
    toOrderBill(row) {
      this.$router.push({
        name: "orderBill",
        query: {
          id: row.id,
          isEdit: "0",
        },
      });
    },
    toEditOrder(row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          isEdit: "1",
        },
      });
    },
    toRefundOrderCannel(row) {
      this.$confirm(this.$t("orderList.orderList86"), "", {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/rejectCannel/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("loginR.login13"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList87"),
          });
        });
    },
    toRefundOrder(row) {
      this.$confirm(
        this.$t("orderList.orderList88"),
        this.$t("orderList.orderList16"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/rejectByCus/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("loginR.login13"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList87"),
          });
        });
    },
    toDestroyOrder(row) {
      let orderStatus = row.orderStatus;
      let confirmMsg = this.$t("orderList.orderList89");
      if (orderStatus != "0" && orderStatus != "4") {
        confirmMsg = this.$t("orderList.orderList90");
      }

      this.$confirm(confirmMsg, this.$t("orderList.orderList18"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/destroyByCus/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList91"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList92"),
          });
        });
    },
    toDestroyOrderCannel(row) {
      let orderStatus = row.orderStatus;
      let confirmMsg = this.$t("orderList.orderList93");
      this.$confirm(confirmMsg, this.$t("orderList.orderList18"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/destroyCannel/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList91"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList92"),
          });
        });
    },
    toStoreKeeping(row) {
      this.$confirm(
        this.$t("orderList.orderList94"),
        this.$t("orderList.orderList47"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/storeKeeping/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList95"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList96"),
          });
        });
    },
    toSendOrder(row) {
      this.$confirm(
        this.$t("orderList.orderList97"),
        this.$t("orderList.orderList98"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/applySendOrder/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("orderList.orderList99"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList100"),
          });
        });
    },
    toCancelOrder(row) {
      this.$confirm(
        this.$t("orderList.orderList101"),
        this.$t("orderList.orderList102"),
        {
          confirmButtonText: this.$t("submit"),
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: this.$t("cancel"),
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.get(
            `cusArrOrder/cancel/` + row.id
          );
          if (res.code !== 200) {
            this.$message.error(res.message);
          } else {
            this.$message({
              type: "success",
              message: this.$t("wzbg.wz18"),
            });
            await this.getOrderList();
            this.getStatisticalNum();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("orderList.orderList103"),
          });
        });
    },
    toSpiltOrder(row) {
      this.splitDialogVisible = true;
      this.originSpiltOrderInfo = row;
      this.spiltOrderInfo = JSON.parse(JSON.stringify(row));
    },
    splitDialogClosed() {
      this.splitDialogVisible = false;
    },
    splitSave(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this.spiltOrderInfo);
          const { data: res } = await this.$http.post(
            "cusArrOrder/spilt",
            this.spiltOrderInfo
          );
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.splitDialogClosed();
            await this.getOrderList();
            this.getStatisticalNum();
          } else {
            this.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    replySave(formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply();
          this.replyDialogVisible = false;
          this.btnReplyFlag == 0;
        } else {
          this.$message.error(this.$t("orderList.orderList104"));
          return false;
        }
      });
    },
    async quickSave(val, row) {
      const { data: res } = await this.$http.post("/order/quickSave", {
        orderId: row.id,
        goodsNumber: val,
        quickSaveType: 8,
      });
      console.log(res);
    },
    messageAdd(row){
      const {MessageSend} = this
      //提醒
      // MessageSend.replyInfo.messageType = "1";
      // MessageSend.message.onAdd("提醒", [
      //   {
      //     key: "orderId",
      //     type: "elInput", //view
      //     label: "订单编号：",
      //     vModel: row.id,
      //     vBind: { disabled: true },
      //   },
      // ]);
      MessageSend.message.onAdd("", row);
    },
    remind(row) {

      //提醒
      this.handleImgSubmit();
      this.replyDialogVisible = true;
      this.replyMessageInfo = row;
      this.listObj = [];
      this.imgFileList = [];
      this.attachmentList = [];
      this.replyInfo = {
        orderId: row.id,
      };
    },
    clearReplyForm() {
      //弹窗的取消按钮
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    initReplyForm() {
      //初始化弹窗的内容
      this.replyInfo = {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
        attachment: "",
      };
    },
    replyDialogClose() {
      //关闭提醒弹窗
      console.log("close");
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    async addReply() {
      //添加
      if (!this.handleImgSubmit()) {
        return false;
      }
      console.log("replyPicture:" + this.replyInfo.replyPicture);
      var url = "cmUser/message/reply";
      const { data: res } = await this.$http.post(url, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        });
      }
    },
    showImgDialog(index) {
      this.imgDialogVisible = true;
    },
    handleImgSubmit() {
      var _this = this;
      let arr = [];
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v].url);
      });
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t("orderList.orderList105"));
        return false;
      } else {
        if (arr.length > 9) {
          _this.$message.error(this.$t("orderList.orderList138"));
          return false;
        } else {
          _this.replyInfo.replyPicture = arr.toString();
          _this.$emit("successCBK", arr);
          _this.listObj = [];
          _this.imgDialogVisible = false;
        }
        if (_this.attachmentList.length > 0) {
          _this.replyInfo.attachment = JSON.stringify(_this.attachmentList);
        } else {
          _this.replyInfo.attachment = "";
        }

        return true;
      }
    },
    handleImgRemove(file, fileList) {
      // 显示使用
      Oss.imgRemove(file, this.listObj);
    },
    handleImgSuccess(response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
    },
    beforeImgUpload(file) {
      console.log(file);
      const _self = this;
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        _self.$message.error(this.$t("createOrder.createOrder74"));
        return false;
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/;
      if (specialReg.test(file.name)) {
        _self.$message.error(this.$t("createOrder.specialChar"));
        return false;
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key =
              response.data.data.dir + "/order/" + num + "${filename}";
            _self.imgDataObj.dir = response.data.data.dir + "/order";
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num;
            Oss.imgCompress(file, this.listObj, resolve, reject);
          })
          .catch((err) => {
            console.log(err);
            reject(false);
          });
      });
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getOrderList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getOrderList();
    },
    // 排序
    toSort() {
      this.isVisibleSort = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择9个文件，${this.$t("createOrder.createOrder92")} ${
          files.length
        } ${this.$t("createOrder.createOrder93")}，${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      );
    },

    handleRemove(file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i];
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1);
        }
      }
    },
    handlePreview() {
      // console.log(file);
    },
    beforeUploadFile(file) {
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      // const size = file.size / 1024 / 1024
      if (
        extension !== ".xls" &&
        extension !== ".xlsx" &&
        extension !== ".pdf" &&
        extension !== ".mp4" &&
        extension !== ".xlsm" &&
        extension !== ".ai"
      ) {
        this.$message.warning(this.$t("orderList.orderList137"));
        return false;
      }

      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    beforeRemove() {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}？`);
    },
    handleOrderInfo() {
      console.log("success");
      // console.log(data)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `${this.$t("createOrder.createOrder91")}，${this.$t(
          "createOrder.createOrder92"
        )} ${files.length} ${this.$t("createOrder.createOrder93")}，${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      );
    },
    async excelUploadRequest(file) {
      let formdata = new FormData();
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      );
      if (res.code === 200) {
        let { fileName, filePath } = res.data;
        this.attachmentList.push({ name: fileName, url: filePath });
      }
    },
  },
  watch: {
    orderDateRangeValue() {
      this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
      this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
    },
    shipDateRangeValue() {
      this.queryInfo.sendTimeStart = this.shipDateRangeValue[0];
      this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1];
    },
  },
  created() {
    this.orderStatusOptions = [
      { value: "0", label: this.$t("orderList.orderList8") },
      { value: "1", label: this.$t("orderList.orderList6") },
      { value: "2", label: this.$t("orderList.orderList7") },
      { value: "4", label: this.$t("orderList.orderList64") },
      { value: "8", label: this.$t("orderList.orderList65") },
      { value: "12", label: this.$t("orderList.orderList66") },
      { value: "16", label: this.$t("orderList.orderList10") },
      { value: "20", label: this.$t("orderList.orderList33") },
      { value: "24", label: this.$t("orderList.orderList34") },
      { value: "26", label: this.$t("orderList.orderList67") },
      { value: "28", label: this.$t("orderList.orderList68") },
      { value: "32", label: this.$t("orderList.orderList69") },
      { value: "36", label: this.$t("orderList.orderList70") },
      { value: "40", label: this.$t("orderList.orderList71") },
      { value: "44", label: this.$t("orderList.orderList11") },
      { value: "48", label: this.$t("orderList.orderList72") },
      { value: "52", label: this.$t("orderList.orderList73") },
      { value: "56", label: this.$t("status.status4") },
      { value: "60", label: this.$t("orderList.orderList74") },
      { value: "64", label: this.$t("orderList.orderList75") },
      { value: "68", label: this.$t("orderList.orderList76") },
      { value: "72", label: this.$t("orderList.orderList77") },
      { value: "76", label: this.$t("orderList.orderList78") },
      { value: "80", label: this.$t("orderList.orderList79") },
      { value: "82", label: this.$t("orderList.orderList80") },
      { value: "84", label: this.$t("orderList.orderList81") },
      { value: "88", label: this.$t("orderList.orderList82") },
    ];
    this.orderStatusQuery = [
      { value: "4", label: this.$t("orderList.orderList64") },
      { value: "8", label: this.$t("orderList.orderList65") },
      { value: "12", label: this.$t("orderList.orderList66") },
      { value: "16", label: this.$t("orderList.orderList10") },
      { value: "20", label: this.$t("orderList.orderList33") },
      { value: "44", label: this.$t("orderList.orderList11") },
      { value: "48", label: this.$t("orderList.orderList72") },
      { value: "88", label: this.$t("orderList.orderList82") },
    ];
    this.getStatisticalNum();
    this.getAsyncColumns().then(() => {
      this.getOrderList();
    });
    // this.getConfigLists();
  },
};
</script>

<style lang="less" scoped>
.paste-img {
  position: absolute;
  width: 1px;
  height: 1px;
  top: 0;
  left: 150px;
  z-index: 999;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
.search-btn-container {
  padding: 0;
}
.query-title1 {
  /* padding-right: 10px; */
  height: 30px;
  line-height: 30px;
  width: 125px;
  padding: 0 10px 0 10px;
  text-align: right;
}
.btn {
  width: 120px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  height: auto;
  overflow: hidden;
}
.lx-text-left-row {
  display: flex;
}
.lx-table-wrapper {
  padding-bottom: 43px;
  box-sizing: content-box;
}
.lx-page-pagination {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 100%;
  height: 35px;
  background-color: #fff;
}
@media screen and (min-width: 1000px) and (max-width: 1550px) {
  .search-btn {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
